module.exports = __webpack_public_path__ + "static/fail.b0e4e028.png";